/* istanbul ignore file */
function downloadFile(_a) {
    var fileName = _a.fileName, file = _a.file;
    var element = document.createElement("a");
    var url = window.URL.createObjectURL(file);
    element.setAttribute("href", url);
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.dispatchEvent(new MouseEvent("click", {
        bubbles: false,
        cancelable: true,
        view: window
    }));
    document.body.removeChild(element);
    window.setTimeout(function () {
        window.URL.revokeObjectURL(url);
    }, 0);
}

export { downloadFile as default };
//# sourceMappingURL=downloadFile.esm.js.map
